import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import { createDropdownItemByValueAndText } from 'utils/reactSemanticUtils';
import {
  APPEND_NPWP_DETAIL_ERROR_MESSAGES,
  SET_NPWP_EDIT_MODAL_LOADING,
  SET_NPWP_EDIT_MODAL_SHOWN,
  SET_NPWP_APPROVE_MODAL_LOADING,
  SET_NPWP_APPROVE_MODAL_SHOWN,
  SET_NPWP_BUSINESS_LIST,
  SET_NPWP_BUSINESS_LIST_IS_LOADING,
  SET_NPWP_DETAIL_APPROVAL_LOGS,
  SET_NPWP_DETAIL_BUSINESS_DETAILS,
  SET_NPWP_DETAIL_ERROR_MESSAGES,
  SET_NPWP_DETAIL_LOADING_STATES,
  SET_NPWP_DETAIL_MODAL_SHOWN,
  SET_NPWP_DETAIL_NPWP_DETAILS,
  SET_NPWP_LIST_FILTERS,
  SET_NPWP_REJECT_MODAL_LOADING,
  SET_NPWP_REJECT_MODAL_SHOWN,
  SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN,
  SET_NPWP_REVIEW_DETAILS_MODAL_LOADING,
} from 'state/actionTypes';

const businessListFilterInitialState = {
  startCreatedDate: null,
  endCreatedDate: null,
  npwpStatus: 'all',
  npwpStatusOptions: [
    createDropdownItemByValueAndText('all', 'All'),
    createDropdownItemByValueAndText('pending', 'Waiting for Approval'),
    createDropdownItemByValueAndText('approved', 'Approved'),
    createDropdownItemByValueAndText('rejected', 'Rejected'),
  ],
  searchKeyword: '',
  searchBy: 'user_email',
  searchByOptions: [
    { key: 'user_email', value: 'user_email', text: 'User Email' },
    { key: 'user_name', value: 'user_name', text: 'User Name' },
    { key: 'business_email', value: 'business_email', text: 'Business Email' },
    { key: 'business_name', value: 'business_name', text: 'Business Name' },
    { key: 'phone', value: 'phone', text: 'Phone' },
  ],
};

const businessListFilters = createReducer(businessListFilterInitialState, {
  [SET_NPWP_LIST_FILTERS]: (state, { payload }) => ({ ...state, ...payload }),
});

const businessesInitialState = {
  list: [],
  page: 1,
  size: 20,
  total: 0,
};
const businesses = createReducer(businessesInitialState, {
  [SET_NPWP_BUSINESS_LIST]: (state, { payload }) => payload,
});

const businessListIsLoading = createReducer(false, {
  [SET_NPWP_BUSINESS_LIST_IS_LOADING]: (state, { payload }) =>
    payload.isLoading,
});

const businessDetailInitialState = {
  business: null,
  modalShown: false,
  loadingStates: {
    business: false,
    npwp: false,
    log: false,
  },
  npwp: null,
  errorMessages: [],
  approvalLogs: {
    last_log: null,
    logs: [],
  },
  approveModal: {
    shown: false,
    isLoading: false,
  },
  rejectModal: {
    shown: false,
    isLoading: false,
  },
  editNpwpModal: {
    shown: false,
    isLoading: false,
  },
  reviewDetailsModal: {
    shown: false,
    isLoading: false,
  },
};
const businessDetail = createReducer(businessDetailInitialState, {
  [SET_NPWP_DETAIL_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    modalShown: payload.shown,
  }),
  [SET_NPWP_DETAIL_ERROR_MESSAGES]: (state, { payload }) => ({
    ...state,
    errorMessages: payload.errorMessages,
  }),
  [APPEND_NPWP_DETAIL_ERROR_MESSAGES]: (state, { payload }) => ({
    ...state,
    errorMessages: [...state.errorMessages, ...payload.errorMessages],
  }),
  [SET_NPWP_DETAIL_LOADING_STATES]: (state, { payload }) => ({
    ...state,
    loadingStates: {
      ...state.loadingStates,
      ...payload.loadingStates,
    },
  }),
  [SET_NPWP_DETAIL_BUSINESS_DETAILS]: (state, { payload }) => ({
    ...state,
    business: payload.business,
  }),
  [SET_NPWP_DETAIL_NPWP_DETAILS]: (state, { payload }) => ({
    ...state,
    npwp: payload.npwp,
  }),
  [SET_NPWP_DETAIL_APPROVAL_LOGS]: (state, { payload }) => ({
    ...state,
    approvalLogs: payload.approvalLogs,
  }),
  [SET_NPWP_APPROVE_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    approveModal: {
      ...state.approveModal,
      shown: payload.shown,
    },
  }),
  [SET_NPWP_APPROVE_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    approveModal: {
      ...state.approveModal,
      isLoading: payload.isLoading,
    },
  }),
  [SET_NPWP_REJECT_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    rejectModal: {
      ...state.rejectModal,
      shown: payload.shown,
    },
  }),
  [SET_NPWP_REJECT_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    rejectModal: {
      ...state.rejectModal,
      isLoading: payload.isLoading,
    },
  }),
  [SET_NPWP_REVIEW_DETAILS_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    reviewDetailsModal: {
      ...state.reviewDetailsModal,
      shown: payload.shown,
    },
  }),
  [SET_NPWP_REVIEW_DETAILS_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    reviewDetailsModal: {
      ...state.reviewDetailsModal,
      isLoading: payload.isLoading,
    },
  }),
  [SET_NPWP_EDIT_MODAL_SHOWN]: (state, { payload }) => ({
    ...state,
    editNpwpModal: {
      ...state.editNpwpModal,
      shown: payload.shown,
    },
  }),
  [SET_NPWP_EDIT_MODAL_LOADING]: (state, { payload }) => ({
    ...state,
    editNpwpModal: {
      ...state.editNpwpModal,
      isLoading: payload.isLoading,
    },
  }),
});

export default combineReducers({
  businesses: combineReducers({
    data: businesses,
    filters: businessListFilters,
    isLoading: businessListIsLoading,
  }),
  businessDetail,
});
